{
	"backToStartPage": "Wróć do strony startowej",
	"transactionDetailsTitle": "Szczegóły transakcji",
	"btnVerifyTransactions": "Zweryfikuj transakcje",
	"kpi": {
		"date": "Data",
		"quantity": "Ilość",
		"carbonReductions": "Redukcje emisji CO\u2082"
	},
	"verifyTransactionModal": {
		"title": "Zweryfikuj transakcję",
		"description": "Wprowadź Record ID dla tej transakcji. Informacje znajdziesz na deklaracji.",
		"recordIdLabel": "Record ID",
		"cancelTitle": "Anuluj",
		"verifyTitle": "Zweryfikuj",
		"errors": {
			"recordIdRequired": "Record ID jest wymagany",
			"recordIdInvalid": "Record ID must be 16 characters (letters or numbers), formatted like ABCD 1234 EFGH 5678",
			"verificationFailed": "Nie udało się zweryfikować transakcji. Sprawdź Record ID"
		}
	},
	"errors": {
		"notFound": "Nie znaleziono transakcji"
	}
}
